import {
  ItemDetailsDto,
  ItemDetailsSidebarSectionResp,
} from '@marketplace-web/item-page/item-page-data'
import { getBumpableItemThumbnailFromDto } from '@marketplace-web/vas/vas-data'

import { ItemPageBumpActionModel } from '../types'

export const getItemPageBumpActionPluginModel = (
  itemDto: ItemDetailsDto,
): ItemPageBumpActionModel => ({
  id: itemDto.id,
  userId: itemDto.user.id,
  title: itemDto.title,
  thumbnail: getBumpableItemThumbnailFromDto(itemDto.photos),
  isPromoted: itemDto.promoted,
  isReserved: itemDto.is_reserved,
  isClosed: itemDto.is_closed,
  canPushUp: itemDto.can_push_up,
})

export const getServerItemPageBumpActionPluginModel = (
  sidebarDto: ItemDetailsSidebarSectionResp,
): ItemPageBumpActionModel => ({
  id: sidebarDto.id,
  userId: sidebarDto.seller_id,
  title: sidebarDto.title,
  thumbnail: getBumpableItemThumbnailFromDto(sidebarDto.photos),
  isPromoted: sidebarDto.promoted,
  isReserved: sidebarDto.is_reserved,
  isClosed: sidebarDto.is_closed,
  canPushUp: sidebarDto.can_push_up,
})
